export const FirebaseConfig = {
	"projectId": "ryyd-e9e6e",
	"appId": "1:524914203954:web:1c18c0a2b63867546b0b2b",
	"databaseURL": "https://ryyd-e9e6e-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "ryyd-e9e6e.firebasestorage.app",
	"apiKey": "AIzaSyA4WRLKz2RMyWfkww9OWaXyMRe54UgcL2k",
	"authDomain": "ryyd-e9e6e.firebaseapp.com",
	"messagingSenderId": "524914203954",
	"measurementId": "G-CB06W96VVJ",
	"projectNumber": "524914203954",
	"version": "2"
};